import { AfterViewInit, Component, ElementRef, forwardRef, Inject, Input, NgZone, PLATFORM_ID } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TransferState } from '@angular/platform-browser';
import { ConvertHelper } from '@barthauer/abc/core';
import {
  DxDateBoxComponent,
  DxTemplateHost,
  IterableDifferHelper,
  NestedOptionHost,
  WatcherHelper,
} from 'devextreme-angular';
import { AbcTooltipDirective } from '../abc-tooltip.directive';
import { AbcCoreComponentService } from '../abcCoreComponent.service';

@Component({
  selector: 'abc-date-box',
  standalone: true,
  providers: [
    DxTemplateHost,
    WatcherHelper,
    IterableDifferHelper,
    NestedOptionHost,
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => AbcDateBoxComponent),
    },
  ],
  template: '',
})
export class AbcDateBoxComponent extends DxDateBoxComponent implements AfterViewInit {
  @Input() public isConverted = false;
  @Input() public showClearButtonOnFocusOnly: boolean = undefined;

  private format: Object = { year: 'numeric', month: '2-digit', day: '2-digit' };

  constructor(
    elementRef: ElementRef,
    ngZone: NgZone,
    templateHost: DxTemplateHost,
    _watcherHelp: WatcherHelper,
    _idh: IterableDifferHelper,
    optionHost: NestedOptionHost,
    transferState: TransferState,
    @Inject(PLATFORM_ID) platformId: any,
    private abcCoreComponentService: AbcCoreComponentService
  ) {
    super(elementRef, ngZone, templateHost, _watcherHelp, _idh, optionHost, transferState, platformId);

    this.pickerType = 'calendar';
    this.labelMode = 'floating';
    this.stylingMode = this.stylingMode ?? this.abcCoreComponentService.stylingMode;

    const tooltTip = new AbcTooltipDirective(this.element);
    tooltTip.elementClassName = '.dx-texteditor-input';
    this.onValueChanged.subscribe((event) => {
      this.formatType(event);
    });

    this.onInitialized.subscribe(() => {
      this.instance.registerKeyHandler('del', () => {
        this.value = null;
      });
    });

    this.onOpened.subscribe(() => {
      this.setClearButtonVisibleIfNecessary(true);
    });
    this.onClosed.subscribe(() => {
      this.setClearButtonVisibleIfNecessary(false);
    });
  }

  ngAfterViewInit() {
    this.displayFormat = this.displayFormat ?? (this.type === DateBoxType.Date ? this.format : null);

    if (this.type === DateBoxType.Date) {
      this.pickerType = 'calendar';
    } else if (this.type === DateBoxType.Time) {
      this.pickerType = 'list';
    }

    this.instance.endUpdate();
    this.setClearButtonVisibleIfNecessary(false);
  }

  private setClearButtonVisibleIfNecessary(visible: boolean) {
    if (this.showClearButtonOnFocusOnly) {
      if (visible) {
        this.showClearButton = true;
      } else {
        this.showClearButton = false;
      }
    }
  }

  getValidationStatus() {
    return this.instance.option('isValid');
  }

  private formatType(event) {
    let value = event.value;
    const dateType = typeof value;
    let result;
    if (!value) {
      value = null;
    }

    //FIXME dateType test should be removed
    if (!this.isConverted) {
      if (value && this.type == DateBoxType.Time && dateType == 'object') {
        result = value.toISOString().slice(0, 10) + 'T' + ConvertHelper.toISOTimeString(value);
      } else if (value && this.type == DateBoxType.Date && dateType == 'object') {
        result =
          value.getFullYear() +
          '-' +
          ('0' + (value.getMonth() + 1)).slice(-2) +
          '-' +
          ('0' + value.getDate()).slice(-2);
      } else if (this.type == DateBoxType.Time && dateType == 'string' && !event.value.includes('T')) {
        //devextreme date box does not accept time as value (example 00:00:00) making a problem in the onValueChanged event
        result = '1753-01-01T00:00:00';
      } else {
        result = value;
      }
      this.onChange.emit(result);
    } else {
      this.onChange.emit(value);
    }
  }
}

export enum DateBoxType {
  Date = 'date',
  Time = 'time',
}
